import { createDynamicMiddleware } from '@reduxjs/toolkit/react';

export { authentication } from '@perpay-web/authentication/singleton';
export const dynamicMiddleware = createDynamicMiddleware();
